export default "__VITE_ASSET__C33NcVb1__"